import { render, staticRenderFns } from "./call-recording-audio.vue?vue&type=template&id=c0e1b128&scoped=true&"
import script from "./call-recording-audio.vue?vue&type=script&lang=js&"
export * from "./call-recording-audio.vue?vue&type=script&lang=js&"
import style0 from "./call-recording-audio.vue?vue&type=style&index=0&id=c0e1b128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e1b128",
  null
  
)

export default component.exports